<template>
  <div>
    <input
      type="text"
      class="nputSearch"
      placeholder="Recherche"
      v-model="user_query"
      @change="SearchProduct()"
    />

    <div v-if="productsList.length">
      <button @click="GetCategorie()" class="btn viewBtn btnRetourCat">Retour aux {{parent}}s</button>
      <h4 class="title-cat">{{ categorie }}</h4>
      <ul class="products-list">
        <li v-for="produit in productsList" :key="produit.id">
          <div class="viewImg"><img v-if="produit.image" :src="produit.image" /></div>
          <div class="viewProduct">
            <div class="viewName text-truncate">{{ produit.name }}</div>
            <div class="viewDescribe" v-html="produit.describe"></div>
          </div>
          <button v-if="produit.available_in_plan" @click="AddProduct(produit.id)" class="btn viewBtn" title="Ajouter sur le plan">
            <font-awesome-icon icon="plus" /> Plan
          </button>
          <button v-else @click="AddProductSoumission(produit.id)" class="btn viewBtn" title="Ce produit ne peut-être ajouté sur le plan mais sera ajouté à votre demande de soumission">
            <font-awesome-icon icon="plus" /> Soumission
          </button>
        </li>
      </ul>
    </div>

    <div v-else-if="subcategory != 1">
      <button @click="GetCategorie(); subcategory = 1" class="btn viewBtn btnRetourCat">Retour aux catégories</button>
      <h4 class="title-cat">{{ parent }}</h4>
      <ul class="categories-list">
        <li v-for="subcategorie in categoriesList" :key="subcategorie.id">
          <div v-if="subcategorie.show_in_plan && subcategorie.parent == subcategory">
            <img v-if="subcategorie.image" :src="subcategorie.image" />
            <p>
              <button
                @click="ProductsCategorie(subcategorie.slug, subcategorie.name)"
                class="btn viewBtn"
              >{{ subcategorie.name }}</button>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div v-else>
      <ul class="categories-list">
        <li v-for="categorie in categoriesList" :key="categorie.id">
          <div v-if="categorie.show_in_plan && categorie.parent == 1">
            <img v-if="categorie.image" :src="categorie.image" />
            <p>
              <button @click="GetSubcategorie(categorie.id, categorie.name)" class="btn viewBtn">{{ categorie.name }}</button>
              <!--<button
                @click="ProductsCategorie(categorie.slug, categorie.name)"
                class="btn viewBtn"
              >{{ categorie.name }}</button>-->
            </p>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      categorie: "",
      parent: "",
      subcategory: 1,
      categoriesList: "",
      productsList: "",
      user_query: ""
    };
  },
  methods: {
    GetCategorie() {
      this.productsList = "";
    },
    PrepareData: function() {
      this.$http
        .get(this.$url_name + "/category/", {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          this.categoriesList = response.body;
        })
        .catch(err => {
          console.log(err);
        });
    },
    GetSubcategorie: function(parent, cat_name) {
      this.productsList = [];
      this.subcategory = parent
      this.parent = cat_name
    },
    ProductsCategorie: function(categorie_slug, cat_name) {

      this.productsList = [];

      this.$http.get(this.$url_name + "/search/?cat=" + categorie_slug, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          this.productsList = response.body;
          if (this.productsList.length == 0) {
            alert('Aucun produit pour cette catégorie pour l\'instant')
          } else {
            this.categorie = cat_name
          }
          
        })
        .catch(err => {
          console.log(err);
        });
    },
    AddProduct: function(product_id) {

      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }


      var data = {
        products: [{ product: product_id, qty: 1, "copy_product_infos": true }]
      };

      this.$http
        .put(
          this.$url_name + "/submission/" + this.$route.params.sid + "/",
          data,
          {
            headers: dheader
          }
        )
        .then(response => {

          var added_product_pk = response.body.products[response.body.products.length-1].id

          this.$emit("NewProductAdded", product_id, added_product_pk);

          this.$toasted.show("Produit ajouté à votre plan avec succès.", {
                  duration: 4000,
                  type: "success"
                });
        })
        .catch(err => {
          console.log(err);
        });

      
    },
    AddProductSoumission: function(product_id) {

      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }


      var data = {
        products: [{ product: product_id, qty: 1, "copy_product_infos": true }]
      };

      this.$http
        .put(
          this.$url_name + "/submission/" + this.$route.params.sid + "/",
          data,
          {
            headers: dheader
          }
        )
        .then(response => {

          var products_soumission = response.body.products

          var last_product = products_soumission[products_soumission.length-1]

          this.$toasted.show("Produit ajouté à votre soumission avec succès.", {
                  duration: 4000,
                  type: "success"
                });

        })
        .catch(err => {
          // console.log(err);
        });

      
    },
    SearchProduct: function() {
      this.productsList = [];

      this.$http
        .get(this.$url_name + "/search/?q=" + this.user_query, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          this.productsList = response.body;

          if (this.productsList == 0) {
            alert("Aucun produit trouvé pour votre recherche");
          }
        })
        .catch(err => {
          // console.log(err);
        });
    }
  },
  mounted() {
    this.PrepareData();
    //this.CreateCanvas();
  }
};
</script>

<style scoped>
.title-cat {
  margin-top: 5px;
}
.categories-list {
  list-style-type: none;
  padding-left: 0px;
}
.categories-list li button {
  width: 200px;
  height: 50px;
}
.products-list {
  list-style-type: none;
  padding-left: 0px;
  padding-right: 10px;
}
.products-list li {
  white-space: normal;
  width: 300px;
  max-width: 100%;
  margin-bottom: 20px;
}
.btn.viewBtn.btnIcon{
    border: none;
    font-size: 20px;
    line-height: 100%;
    font-weight: 400
}
/* MC-PRONOVOST */
.viewProduct {
  height: 1.5em;
  position: relative;
}
.products-list li .viewImg {
  overflow:hidden;
  height: 250px;
  width: 250px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.products-list li .viewImg img{width:100%}
.viewProduct .viewName {
  cursor: help;
}
.viewDescribe {
  background: rgba(0, 0, 0, 0.9);
  border: 2px solid #000;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  display: none;
  position: absolute;
  left: 3em;
  right: 3em;
  bottom: 1em;
  z-index: 10;
  padding: 1em;
}
.viewProduct:hover .viewDescribe {
  display: inline-block;
}
.products-list li .btn.viewBtn.btnIcon{
    padding:1px
}
.btn.viewBtn.btnRetourCat{margin-top:1em}
.nputSearch {width: 90%; height: 40px;}
@media (max-width: 1199px) {
  .categories-list > li {
    display: inline-block;
    margin: 1px 5px;
  }
  .nputSearch {
    width: 90%;
  }
  .boxRight .products-list {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    display: block;
    width: auto;
    height: 340px;
  }
  .boxRight .products-list > li {
    display: inline-block;
    margin-right:5px
  }
  .viewDescribe {
    white-space: normal;
    max-height: 250px;
    left: 0;
    right: 0;
    overflow: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Product.vue